import { get } from "lodash";

export const checkProductHasUpsells = async (getOffer, insurancePlanId) => {
  const { data } = await getOffer({
    variables: {
      where: {
        AND: [
          {
            offerInsurancePlans: {
              insurancePlan: { id: insurancePlanId },
              main: true,
            },
          },
        ],
      },
    },
  });
  const mainOfferId = get(data, "offer.id", null);
  if (!mainOfferId) return false;

  const { data: offer } = await getOffer({
    fetchPolicy: "no-cache",
    variables: {
      where: {
        AND: [{ id: mainOfferId }, { offerInsurancePlans: { main: false } }],
      },
    },
  });

  return !!get(offer, "offer.offerInsurancePlans", []).length;
};

export const getMainOfferQueryVariables = (insurancePlanId) => ({
  where: {
    AND: [
      {
        offerInsurancePlans: {
          insurancePlan: { id: insurancePlanId },
          main: true,
        },
      },
    ],
  },
});
